import FilesApi from 'remote/files'

export async function uploadToGoogle({ apiToken, apiEndpoint }, { file }) {
  try {
    return FilesApi.uploadFile(
      { apiToken, apiEndpoint },
      { file, isTemporary: true }
    )
  } catch (error) {
    return null
  }
}
